import React from "react";
import ServicesList from "../../Components/Services/ServicesList";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import { Helmet } from "react-helmet";

// You can import a specific image for the banner here
import bannerImage from "../../assets/images/Herosection/herobanner.jpg"; 

const brandColors = {
  cream: "#F3EEE4",
  creamDark: "#EAE2D3",
  crimson: "#A10F1A",
  crimsonDark: "#7A0C14",
  gold: "#C79A3B",
  goldLight: "#D9B56B",
  black: "#1A1A1A",
  brown: "#5A3A1A",
};

const PracticeAreas = () => {
  return (
    <>
      <Helmet>
        <title>Practice Areas - R & P Law Partners Chambers</title>
        <meta
          name="description"
          content="Explore the diverse practice areas of R & P Law Partners Chambers. Expert legal solutions in civil, criminal, corporate and family law delivered by experienced attorneys."
        />
        <meta
          name="keywords"
          content="R & P Law Partners, Law Firm, Practice Areas, Civil Law, Criminal Law, Corporate Law, Family Law, Attorneys"
        />
        <noscript>
          Please enable JavaScript to view this page properly.
        </noscript>
      </Helmet>

      <Header />

      {/* --- Custom Practice Areas Banner (Styled like HeroSection) --- */}
      <section
        className="relative text-white pt-24 pb-20 lg:pt-32 lg:pb-28 overflow-hidden flex items-center justify-center"
        style={{ background: "#0d0505", minHeight: "45vh" }}
      >
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src={bannerImage}
            alt="Law Expertise"
            className="w-full h-full object-cover"
            style={{ filter: "brightness(0.3) saturate(1.2)", objectPosition: "center 30%" }}
          />

          {/* Gradient Overlay */}
          <div
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(135deg, rgba(139,26,26,0.65) 0%, rgba(13,5,5,0.85) 55%)",
            }}
          />
        </div>

        {/* Gold top border */}
        <div
          className="absolute top-0 left-0 right-0 z-10"
          style={{
            height: "3px",
            background: `linear-gradient(90deg, transparent, ${brandColors.gold}, ${brandColors.crimson}, ${brandColors.gold}, transparent)`,
          }}
        />

        {/* Banner Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center flex flex-col items-center">
          {/* Eyebrow */}
          <div className="flex items-center gap-3 mb-4">
            <span
              style={{
                width: "40px",
                height: "1px",
                background: `linear-gradient(270deg, ${brandColors.gold}, transparent)`,
              }}
            />
            <span
              style={{
                fontFamily: "'Cinzel', serif",
                fontSize: "12px",
                letterSpacing: "0.25em",
                color: brandColors.gold,
                textTransform: "uppercase",
              }}
            >
              Our Expertise
            </span>
            <span
              style={{
                width: "40px",
                height: "1px",
                background: `linear-gradient(90deg, ${brandColors.gold}, transparent)`,
              }}
            />
          </div>

          {/* Heading */}
          <h1
            style={{
              fontFamily: "'Cinzel', serif",
              fontSize: "clamp(36px, 5vw, 64px)",
              fontWeight: 700,
              lineHeight: 1.15,
              letterSpacing: "0.04em",
              textTransform: "uppercase",
              color: brandColors.cream,
              marginBottom: "16px",
            }}
          >
            Practice <span style={{ color: brandColors.gold }}>Areas</span>
          </h1>

          {/* Divider */}
          <div className="flex items-center justify-center gap-3 my-4 w-full max-w-xs">
            <div
              style={{
                flex: 1,
                height: "0.5px",
                background: `linear-gradient(90deg, transparent, ${brandColors.gold})`,
              }}
            />
            <div
              style={{
                width: "6px",
                height: "6px",
                border: `1px solid ${brandColors.gold}`,
                transform: "rotate(45deg)",
              }}
            />
            <div
              style={{
                flex: 1,
                height: "0.5px",
                background: `linear-gradient(90deg, ${brandColors.gold}, transparent)`,
              }}
            />
          </div>

          {/* Subtext */}
          <p
            style={{
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontSize: "18px",
              fontStyle: "italic",
              color: "rgba(245,240,232,0.80)",
              lineHeight: 1.7,
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            Comprehensive legal solutions tailored to protect your rights. Discover our specialized domains of practice.
          </p>
        </div>

        {/* Watermark */}
        <div
          className="absolute bottom-[-10%] left-1/2 -translate-x-1/2 pointer-events-none select-none z-0"
          style={{
            fontFamily: "'Cinzel', serif",
            fontSize: "clamp(60px, 15vw, 120px)",
            fontWeight: 700,
            color: "rgba(139,26,26,0.07)",
            lineHeight: 1,
            textTransform: "uppercase",
            whiteSpace: "nowrap",
          }}
        >
          Expertise
        </div>
      </section>
      {/* ------------------------------------------------------------- */}

      <ServicesList />
      <Footer />
    </>
  );
};

export default PracticeAreas;